import { API, graphqlOperation } from "aws-amplify";
import {
  CreateVocabularyNewWordList,
  CreateWordAndAddToWordList,
  DeleteWordFromWordList,
  DeleteWordList,
  EditNoteForWord,
  EditWordList,
  GetVocabularyContents,
  GetVocabularySearchedWord,
  GetVocabularyWordList,
  UpdateWordToWordList,
} from "../../queries";
import {
  SET_TOPIC_LIST_DATA,
  CREATE_VOCABULARY_WORDLIST,
  CREATE_VOCABULARY_WORDLIST_FAILURE,
  CREATE_VOCABULARY_WORDLIST_SUCCESS,
  GET_VOCABULARY_CONTENTS,
  GET_VOCABULARY_CONTENTS_FAILURE,
  GET_VOCABULARY_CONTENTS_SUCCESS,
  GET_VOCABULARY_SEARCHED_WORD,
  GET_VOCABULARY_SEARCHED_WORD_FAILURE,
  GET_VOCABULARY_SEARCHED_WORD_SUCCESS,
  GET_VOCABULARY_WORD_LIST,
  GET_VOCABULARY_WORD_LIST_FAILURE,
  GET_VOCABULARY_WORD_LIST_SUCCESS,
  RESET_CREATED_WORDLIST_STATUS,
  RESET_UPDATE_VOCABULARY_WORD_STATUS,
  RESET_VOCABULARY_ADD_WORD,
  RESET_VOCABULARY_ADD_WORD_TO_LIST,
  RESET_VOCABULARY_DELETE_WORD,
  RESET_VOCABULARY_DELETE_WORDLIST,
  RESET_VOCABULARY_UPDATE_WORD_LIST,
  UPDATE_VOCABULARY_WORD_NOTE,
  UPDATE_VOCABULARY_WORD_NOTE_FAILURE,
  UPDATE_VOCABULARY_WORD_NOTE_SUCCESS,
  VOCABULARY_ADD_WORD,
  VOCABULARY_ADD_WORD_FAILURE,
  VOCABULARY_ADD_WORD_SUCCESS,
  VOCABULARY_ADD_WORD_TO_LIST,
  VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
  VOCABULARY_ADD_WORD_TO_LIST_SUCCESS,
  VOCABULARY_DELETE_WORD,
  VOCABULARY_DELETE_WORDLIST,
  VOCABULARY_DELETE_WORDLIST_FAILURE,
  VOCABULARY_DELETE_WORDLIST_SUCCESS,
  VOCABULARY_DELETE_WORD_FAILURE,
  VOCABULARY_DELETE_WORD_SUCCESS,
  VOCABULARY_RESET_SEARCH_PARAMS,
  VOCABULARY_UPDATE_WORD_LIST,
  VOCABULARY_UPDATE_WORD_LIST_FAILURE,
  VOCABULARY_UPDATE_WORD_LIST_SUCCESS,
} from "../constants";
import { removeSpecialCharacters } from "../../components/core/VocabularyCenter-POC/VocabularyCenterPOCUtils";
export const processTopics = (topics: any, isUserWordList = false) =>
  Object.entries(topics)
      .filter(([key]) => (key !== "totalWordCount" && key !== "totalWordlistCount"))   
      .map(([key, value]) => ({
      topic: key,
      headerTitle: removeSpecialCharacters(key),
      listDetails: value as any[], // Type assertion to treat value as an array
      listLength: (value as any[])?.length, // Type assertion to treat value as an array
      isUserWordList,
    }));
export const getVocabularyContents = (geId: string, token: string, accountId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_VOCABULARY_CONTENTS });
    const getVocabularyContentsDetails = API.graphql(
      graphqlOperation(GetVocabularyContents, { geId, token, accountId }),
    ) as Promise<any>;
    getVocabularyContentsDetails
      .then(async (getVocabularyContents: any) => {
        if (getVocabularyContents && getVocabularyContents.data) {
          const parsedData = JSON.parse(getVocabularyContents.data.getVocabularyContents);
          const { Common: commonTopics, Organization: organizationTopics, User: userTopics } = parsedData;
          const topicsList = [
            ...processTopics(commonTopics),
            ...processTopics(organizationTopics),
            {
              topic: "userWordlists",
              headerTitle: "My word lists",
              listDetails: userTopics.userWordlists ?? [],
              listLength: userTopics.userWordlists?.length ?? 0,
              isUserWordList: true,
            },
          ];

          await Promise.all([
            dispatch({
              type: GET_VOCABULARY_CONTENTS_SUCCESS,
              payload: JSON.parse(getVocabularyContents.data.getVocabularyContents),
            }),
            dispatch({
              type: SET_TOPIC_LIST_DATA,
              payload: topicsList,
            }),
          ]);
        } else {
          dispatch({
            type: GET_VOCABULARY_CONTENTS_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: GET_VOCABULARY_CONTENTS_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const getVocabularyWordList = (
  geId: string,
  token: string,
  wordListId: string,
  customFieldValue: string,
  language: string,
) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_VOCABULARY_WORD_LIST });
    const getVocabularyWordListDetails = API.graphql(
      graphqlOperation(GetVocabularyWordList, { geId, token, wordListId, customFieldValue, language }),
    ) as Promise<any>;
    getVocabularyWordListDetails
      .then(async (getVocabularyWordLists: any) => {
        if (getVocabularyWordLists && getVocabularyWordLists.data) {
          dispatch({
            type: GET_VOCABULARY_WORD_LIST_SUCCESS,
            payload: JSON.parse(getVocabularyWordLists.data.getVocabularyWordList),
          });
        } else {
          dispatch({
            type: GET_VOCABULARY_WORD_LIST_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: GET_VOCABULARY_WORD_LIST_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const getVocabularySearchedWord = (
  geId: string,
  token: string,
  searchedText: string,
  userType: string,
  isCaseSensitive: number,
) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_VOCABULARY_SEARCHED_WORD });
    const getVocabularySearchedWordDetails = API.graphql(
      graphqlOperation(GetVocabularySearchedWord, { geId, token, searchedText, userType, isCaseSensitive }),
    ) as Promise<any>;
    getVocabularySearchedWordDetails
      .then(async (getVocabularySearchedWord: any) => {
        if (getVocabularySearchedWord?.data) {
          dispatch({
            type: GET_VOCABULARY_SEARCHED_WORD_SUCCESS,
            payload: JSON.parse(getVocabularySearchedWord.data.getVocabularySearchedWord),
          });
        } else {
          dispatch({
            type: GET_VOCABULARY_SEARCHED_WORD_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: GET_VOCABULARY_SEARCHED_WORD_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetSearchParams = () => {
  return {
    type: VOCABULARY_RESET_SEARCH_PARAMS,
  };
};

export const createVocabularyNewWordList = (token: string, newWordListTitle: string, userType: string) => {
  return async (dispatch: any) => {
    dispatch({ type: CREATE_VOCABULARY_WORDLIST });
    const createVocabularyNewWordListDetails = API.graphql(
      graphqlOperation(CreateVocabularyNewWordList, { token, newWordListTitle, userType }),
    ) as Promise<any>;
    createVocabularyNewWordListDetails
      .then(async (vocabularyCreateNewWordList: any) => {
        if (vocabularyCreateNewWordList?.data) {
          dispatch({
            type: CREATE_VOCABULARY_WORDLIST_SUCCESS,
            payload: JSON.parse(vocabularyCreateNewWordList.data.vocabularyCreateNewWordList),
          });
        } else {
          dispatch({
            type: CREATE_VOCABULARY_WORDLIST_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: CREATE_VOCABULARY_WORDLIST_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetAddListParams = () => {
  return {
    type: RESET_CREATED_WORDLIST_STATUS,
  };
};

export const updateVocabularyEditWordNote = (
  token: string,
  defId: string,
  definition: string,
  sentence: string,
  note: string,
  slang: number,
  posId: number,
) => {
  return async (dispatch: any) => {
    dispatch({ type: UPDATE_VOCABULARY_WORD_NOTE });
    const editVocabularyWordNoteDetails = API.graphql(
      graphqlOperation(EditNoteForWord, { token, defId, definition, sentence, note, slang, posId }),
    ) as Promise<any>;
    editVocabularyWordNoteDetails
      .then(async (updateVocabularyWordNote: any) => {
        if (updateVocabularyWordNote?.data) {
          dispatch({
            type: UPDATE_VOCABULARY_WORD_NOTE_SUCCESS,
            payload: JSON.parse(updateVocabularyWordNote.data.vocabularyEditNote),
          });
        } else {
          dispatch({
            type: UPDATE_VOCABULARY_WORD_NOTE_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: UPDATE_VOCABULARY_WORD_NOTE_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetEditNoteParams = () => {
  return {
    type: RESET_UPDATE_VOCABULARY_WORD_STATUS,
  };
};

export const vocabularyAddWordToList = (
  token: string,
  wordListId: string,
  wordId: string,
  type: string,
  action: string,
  wordlist: string,
) => {
  return async (dispatch: any) => {
    dispatch({ type: VOCABULARY_ADD_WORD_TO_LIST });
    const vocabularyAddWordToList = API.graphql(
      graphqlOperation(UpdateWordToWordList, { token, wordListId, wordId, type, action, wordlist }),
    ) as Promise<any>;
    vocabularyAddWordToList
      .then(async (vocabularyAddWordToListObj: any) => {
        if (vocabularyAddWordToListObj?.data) {
          const parsedResponse = JSON.parse(vocabularyAddWordToListObj.data.vocabularyAddWordToWordList);
          if (parsedResponse.error) {
            dispatch({
              type: VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
              error: parsedResponse.error,
            });
          } else {
            dispatch({
              type: VOCABULARY_ADD_WORD_TO_LIST_SUCCESS,
              payload: parsedResponse,
            });
          }
        } else {
          dispatch({
            type: VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetAddWordToListParams = () => {
  return {
    type: RESET_VOCABULARY_ADD_WORD_TO_LIST,
  };
};

export const vocabularyAddWord = (
  token: string,
  def: string,
  listId: string,
  posId: string,
  pos: string,
  sentence: string,
  slang: number,
  word: string,
  type: string,
  translation?: any,
  note?: any,
) => {
  return async (dispatch: any) => {
    dispatch({ type: VOCABULARY_ADD_WORD });
    const vocabularyAddWord = API.graphql(
      graphqlOperation(CreateWordAndAddToWordList, {
        token,
        def,
        listId,
        posId,
        pos,
        sentence,
        slang,
        word,
        type,
        translation,
        note,
      }),
    ) as Promise<any>;
    vocabularyAddWord
      .then(async (vocabularyAddWordObj: any) => {
        if (vocabularyAddWordObj?.data) {
          const parsedResponse = JSON.parse(vocabularyAddWordObj.data.vocabularyAddNewWord);
          if (parsedResponse.error) {
            dispatch({
              type: VOCABULARY_ADD_WORD_FAILURE,
              error: parsedResponse.error,
            });
          } else {
            dispatch({
              type: VOCABULARY_ADD_WORD_SUCCESS,
              payload: parsedResponse,
            });
          }
        } else {
          dispatch({
            type: VOCABULARY_ADD_WORD_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: VOCABULARY_ADD_WORD_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetAddWordParams = () => {
  return {
    type: RESET_VOCABULARY_ADD_WORD,
  };
};

export const vocabularyDeleteWordList = (token: string, wordListId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: VOCABULARY_DELETE_WORDLIST });
    const vocabularyDeleteWordListDetails = API.graphql(
      graphqlOperation(DeleteWordList, { token, wordListId }),
    ) as Promise<any>;
    vocabularyDeleteWordListDetails
      .then(async (vocabularyDeleteWordList: any) => {
        if (vocabularyDeleteWordList?.data) {
          dispatch({
            type: VOCABULARY_DELETE_WORDLIST_SUCCESS,
            payload: JSON.parse(vocabularyDeleteWordList.data.vocabularyDeleteWordList),
          });
        } else {
          dispatch({
            type: VOCABULARY_DELETE_WORDLIST_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: VOCABULARY_DELETE_WORDLIST_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetDeleteWordListParams = () => {
  return {
    type: RESET_VOCABULARY_DELETE_WORDLIST,
  };
};

export const vocabularyDeleteWord = (token: string, wordListId: string, wordId: string, userType: string) => {
  return async (dispatch: any) => {
    dispatch({ type: VOCABULARY_DELETE_WORD });
    const vocabularyDeleteWordDetails = API.graphql(
      graphqlOperation(DeleteWordFromWordList, { token, wordListId, wordId, userType }),
    ) as Promise<any>;
    vocabularyDeleteWordDetails
      .then(async (vocabularyDeleteWord: any) => {
        if (vocabularyDeleteWord?.data) {
          dispatch({
            type: VOCABULARY_DELETE_WORD_SUCCESS,
            payload: JSON.parse(vocabularyDeleteWord.data.vocabularyDeleteWordFromWordList),
          });
        } else {
          dispatch({
            type: VOCABULARY_DELETE_WORD_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: VOCABULARY_DELETE_WORD_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetDeleteWordParams = () => {
  return {
    type: RESET_VOCABULARY_DELETE_WORD,
  };
};

export const vocabularyUpdateWordList = (token: string, wordListId: string, newTitle: string, userType: string) => {
  return async (dispatch: any) => {
    dispatch({ type: VOCABULARY_UPDATE_WORD_LIST });
    const vocabularyUpdateWordList = API.graphql(
      graphqlOperation(EditWordList, { token, wordListId, newTitle, userType }),
    ) as Promise<any>;
    vocabularyUpdateWordList
      .then(async (vocabularyUpdateWordList: any) => {
        if (vocabularyUpdateWordList?.data) {
          dispatch({
            type: VOCABULARY_UPDATE_WORD_LIST_SUCCESS,
            payload: JSON.parse(vocabularyUpdateWordList.data.vocabularyEditWordList),
          });
        } else {
          dispatch({
            type: VOCABULARY_UPDATE_WORD_LIST_FAILURE,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: VOCABULARY_UPDATE_WORD_LIST_FAILURE,
          error: {
            message: err,
          },
        });
      });
  };
};

export const resetUpdateWordListParams = () => {
  return {
    type: RESET_VOCABULARY_UPDATE_WORD_LIST,
  };
};
